import React, { Component } from "react";
//import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
//import { Left } from "react-bootstrap/lib/Media";
import {
  IModuleDetailProps,
  IModuleDetailState,
} from "../../interfaces/module.interface";
import { AppRoutes } from "../../config";
//import { IRootState } from "../../interfaces";

interface questionReview {
  questionNumber: any;
  question: any;
  flagValue: any;
}
//let localArr: number[] = [];
let flagQuestion: questionReview[] = [];

class QuizReviewFunctionality extends Component<
  IModuleDetailProps,
  IModuleDetailState
> {
  /*constructor(props: IModuleDetailProps) {
    super(props);
  }*/

  componentDidMount() {
    console.log("Component did mount");
    flagQuestion = JSON.parse(localStorage.getItem("flagQuestions") || "[]");
    console.log(flagQuestion, "-------------------------------------------");
  }

  render() {
    return (
      <>
        <div className="main-section module-custom-main" id="right-container">
          <div className="col-lg-12 col-md-12">
            <div className="container">
              <div>
                <Row className="col-lg-6 col-md-6">
                  <Col
                    md={{ span: 6, offset: 10 }}
                    className="quiz-review-head "
                  >
                    Review
                  </Col>
                </Row>
              </div>
              {flagQuestion.length > 0 ? (
                <>
                  <Row className="col-lg-12 col-md-12">
                    <Col md={{ span: 6, offset: 2 }}>
                      <div className="flag-question-parent">
                        <div>
                          <div className="d-flex flex-row flex-wrap">
                            {flagQuestion.map((item, index) => {
                              return (
                                <div className="flag-question-child ">
                                  <div
                                    className="p-1"
                                    style={{
                                      fontSize: "20px",
                                      fontWeight: "bold",
                                      textAlign: "center",
                                    }}
                                  >
                                    {item.flagValue === true ? (
                                      <a
                                        onClick={() => {
                                          this.props.history.push(
                                            AppRoutes.QUIZ
                                          );
                                        }}
                                        // href="http://localhost:3002/student/quiz?name=un"
                                        style={{ color: "red" }}
                                      >
                                        {item.questionNumber}
                                      </a>
                                    ) : (
                                      <a
                                        onClick={() => {
                                          this.props.history.push(
                                            AppRoutes.QUIZ
                                          );
                                        }}
                                        style={{ color: "#8b8a8a" }}
                                      >
                                        {item.questionNumber}
                                      </a>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row className="col-lg-12 col-md-12">
                    <Col md={{ span: 6, offset: 3 }}>
                      <div className="d-flex flex-row justify-content-around flag-idenfier">
                        <div className="d-flex flex-row justify-content-around">
                          <div
                            className="flag-idenfier-circle"
                            style={{ backgroundColor: "#8b8a8a" }}
                          ></div>
                          <div>Answered</div>
                        </div>
                        <div className="d-flex flex-row justify-content-around">
                          <div
                            className="flag-idenfier-circle"
                            style={{ backgroundColor: "red" }}
                          ></div>
                          <div>Flagged Question</div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </>
              ) : (
                <Row className="col-lg-12 col-md-12">
                  <Col md={{ span: 6, offset: 3 }}>
                    <div style={{ marginTop: "20px", textAlign: "center" }}>
                      <h3 style={{ color: "red" }}>Attempt the Quiz first</h3>
                    </div>
                  </Col>
                </Row>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default QuizReviewFunctionality;
